import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../user.service';
import { ResetprofileData, resetResponse } from 'src/interface/profile';
import { UniversalStorageService } from '../../../services/universal-storage.service';

@Component({
    selector: 'app-account-security',
    templateUrl: './account-security.component.html',
    styleUrls: ['./account-security.component.scss'],
})
export class AccountSecurityComponent {
    user_email: string;
    AccountSecurityForm: FormGroup;
    success_message: string;
    error_message: string;
    loginSuccess = false;
    message: string;
    message_error: string;
    constructor(
        private userService: UserService,
        private storageService: UniversalStorageService
    ) {
        const token = this.storageService.getItem('BEARER_TOKEN');
        // Replace with your token storage mechanism
        if (token) {
            const tokenPayload = this.decodeToken(token);
            this.user_email = tokenPayload.data.email;
        }

        this.AccountSecurityForm = new FormGroup({
            new_password: new FormControl('', [Validators.required]),
            retry_password: new FormControl('', [Validators.required]),
        });
    }

    private decodeToken(token: string) {
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            throw new Error('Invalid token format');
        }

        const tokenPayload = JSON.parse(atob(tokenParts[1]));
        return tokenPayload;
    }
    onSubmit() {
        this.success_message = '';
        this.error_message = '';
        if (this.AccountSecurityForm.valid) {
            const newPasswordControl =
                this.AccountSecurityForm.get('new_password');
            const confirmPasswordControl =
                this.AccountSecurityForm.get('retry_password');

            if (newPasswordControl && confirmPasswordControl) {
                const newPassword = newPasswordControl.value;
                const confirmPassword = confirmPasswordControl.value;

                if (newPassword === confirmPassword) {
                    // const formData: ProfileRequest = {
                    const securityData: ResetprofileData = {
                        user_password: btoa(newPassword),
                        user_email: this.user_email,
                        // Add more properties as needed
                    };

                    this.userService
                        .saveProfilePassword(securityData)
                        .subscribe((r: resetResponse) => {
                            // Use 'response' as the type hint
                            if (r.status == 200) {
                                this.loginSuccess = true;
                                this.message = r.message;
                            } else {
                                this.loginSuccess = false;
                                this.message_error = r.message;
                            }
                        });
                } else {
                    this.message_error =
                        'Form is not valid or Language is missing.';
                    // console.log('Form is not valid or Language is missing.');
                }
            }
        }
    }
}
